'use client'
import React, { useState, useEffect } from 'react'
import { getRecommended } from '@services/getRecommended'
import { useSession } from 'next-auth/react'
import dynamic from 'next/dynamic'

const PropertyCardSlider = dynamic(() => import('@components/PropertyCardSlider'))

const i18n = {
  title: { 
    en: 'Similar Listings for You', 
    th: 'รายการที่คล้ายกันสำหรับคุณ', 
    cn: '为您推荐的相似房源', 
    ru: 'Похожие объявления для вас', 
    fr: 'Annonces similaires pour vous', 
    de: 'Ähnliche Angebote für Sie', 
    it: 'Annunci simili per te', 
    ja: 'あなたへのおすすめ物件', 
    ko: '추천 매물', 
    es: 'Anuncios similares para ti', 
    tr: 'Sizin için benzer ilanlar',
    he: 'מודעות דומות עבורך',
    ar: 'عقارات مشابهة مختارة لك' 
  },
}

const t = (val, lang) => {
  if (!val) return ''
  if (typeof val === 'string') return val
  return val[lang] || val['en'] || ''
}

const RecommendedProperties = ({ cellId, website, property, lang = 'en', dictionary }) => {
  const { data: session } = useSession()
  const [recommended, setRecommended] = useState([])

  const allConfigs = website?.elements?.recommended_properties ?? {}
  const config = (cellId && allConfigs[cellId])
    ? allConfigs[cellId]
    : (Object.values(allConfigs)[0] ?? {})

  const {
    showTitle     = true,
    title         = i18n.title,
    showSubtitle  = false,
    subtitle      = {},
    titleSize     = '1.25rem',
    titleWeight   = '600',
    titleColor    = 'var(--color-main)',
    titleAlign    = 'left',
    cardsDesktop  = 3,
    cardsTablet   = 2,
    cardsMobile   = 1,
    limit         = 6,
  } = config

  const userEmail = session?.user?.email ?? null

  useEffect(() => {
    const fetchRecommended = async () => {
      const result = await getRecommended(property.slug, userEmail, lang)
      setRecommended(result?.properties ?? [])
    }
    fetchRecommended()
  }, [property.slug, userEmail, lang])

  if (!recommended.length) return null

  const propertySlider = {
    propertySlider: {
      desktop: cardsDesktop,
      tablet:  cardsTablet,
      mobile:  cardsMobile,
    }
  }

  const resolvedTitle    = t(title,    lang) || i18n.title[lang] || i18n.title.en
  const resolvedSubtitle = t(subtitle, lang)

  return (
    <div className='w-full'>
      {showTitle && resolvedTitle && (
        <h2 style={{
          fontSize:   titleSize,
          fontWeight: titleWeight,
          color:      titleColor,
          textAlign:  titleAlign,
          marginBottom: '1rem',
        }}>
          {resolvedTitle}
        </h2>
      )}
      {showSubtitle && resolvedSubtitle && (
        <p style={{ color: 'var(--color-secondary)', marginBottom: '1rem' }}>
          {resolvedSubtitle}
        </p>
      )}
      <PropertyCardSlider
        title={{ [lang]: '' }}
        description={null}
        propertySlider={propertySlider}
        cardStyle={website.propertySliderCard}
        properties={recommended.slice(0, limit)}
        dictionary={dictionary}
        lang={lang}
      />
    </div>
  )
}

export default RecommendedProperties